<template>
    <div
        class="personalize-page container-fluid page-card weflix-personalize-admin"
    >
        <div class="personalize-tabs-card">
            <nav
                class="personalize-tabs"
                aria-label="Seções de personalização"
            >
                <div class="link">
                    <a
                        class="link-content"
                        :class="[isActiveTab(1) ? 'active' : '']"
                        role="button"
                        tabindex="0"
                        @click="setActiveTab(1)"
                        @keydown.enter.prevent="setActiveTab(1)"
                    >
                        Básico
                    </a>
                </div>
                <div class="link">
                    <a
                        class="link-content"
                        :class="[isActiveTab(3) ? 'active' : '']"
                        role="button"
                        tabindex="0"
                        @click="setActiveTab(3)"
                        @keydown.enter.prevent="setActiveTab(3)"
                    >
                        Temas
                    </a>
                </div>
                <div class="link">
                    <a
                        class="link-content"
                        :class="[isActiveTab(2) ? 'active' : '']"
                        role="button"
                        tabindex="0"
                        @click="setActiveTab(2)"
                        @keydown.enter.prevent="setActiveTab(2)"
                    >
                        Layout
                    </a>
                </div>
                <div class="link redes-sociais-mobile">
                    <a
                        class="link-content"
                        :class="[isActiveTab(4) ? 'active' : '']"
                        role="button"
                        tabindex="0"
                        @click="setActiveTab(4)"
                        @keydown.enter.prevent="setActiveTab(4)"
                    >
                        Redes sociais
                    </a>
                </div>
                <div class="link">
                    <a
                        class="link-content"
                        :class="[isActiveTab(6) ? 'active' : '']"
                        role="button"
                        tabindex="0"
                        @click="setActiveTab(6)"
                        @keydown.enter.prevent="setActiveTab(6)"
                    >
                        Integrações
                    </a>
                </div>
                <div class="link last">
                    <a
                        class="link-content"
                        :class="[isActiveTab(5) ? 'active' : '']"
                        role="button"
                        tabindex="0"
                        @click="setActiveTab(5)"
                        @keydown.enter.prevent="setActiveTab(5)"
                    >
                        Avançado
                    </a>
                </div>
            </nav>
        </div>

        <div class="personalize-shell">
            <div class="personalize-form-panel">
                <section
                    class="section config-form primary personalize-section"
                    :class="[isActiveTab(1) ? 'active' : '']"
                >
                    <Basic />
                </section>
                <section
                    class="section config-form primary personalize-section"
                    :class="[isActiveTab(2) ? 'active' : '']"
                >
                    <LayoutEditor />
                </section>
                <section
                    class="section config-form primary personalize-section"
                    :class="[isActiveTab(3) ? 'active' : '']"
                >
                    <Themes />
                </section>
                <section
                    class="section config-form primary personalize-section"
                    :class="[isActiveTab(4) ? 'active' : '']"
                >
                    <SocialMedia />
                </section>
                <section
                    class="section config-form primary personalize-section"
                    :class="[isActiveTab(5) ? 'active' : '']"
                >
                    <Advanced />
                </section>
                <section
                    class="section config-form primary personalize-section"
                    :class="[isActiveTab(6) ? 'active' : '']"
                >
                    <Integrations />
                </section>
            </div>
        </div>
    </div>
</template>

<script>
    import Basic from '@/components/Weflix/Layout/basic.vue';
    import Advanced from '@/components/Weflix/Layout/advanced.vue';
    import Integrations from '@/components/Weflix/Layout/integrations.vue';
    import LayoutEditor from '@/components/Weflix/Layout/layout.vue';
    import Themes from '@/components/Weflix/Layout/themes.vue';
    import SocialMedia from '@/components/Weflix/Layout/socialMedia.vue';

    export default {
        data() {
            return {
                activeTab: 1,
                hassaved: false,
                openmodalmodule: false,
            };
        },
        props: {},
        components: {
            Basic,
            Advanced,
            Integrations,
            LayoutEditor,
            Themes,
            SocialMedia,
        },
        methods: {
            setActiveTab(tabNumber) {
                this.activeTab = tabNumber;
            },
            isActiveTab(tabNumber) {
                return this.activeTab === tabNumber;
            },
        },
        created() {},
    };
</script>

<style scoped>
    @import url(./global.css);

    .personalize-page.container-fluid.page-card {
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .personalize-tabs-card {
        padding: 1rem;
    }

    .personalize-tabs {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .personalize-tabs .link {
        flex: 0 0 auto;
    }

    .personalize-tabs .link a.link-content {
        display: inline-block;
        font-family:
            Inter,
            system-ui,
            -apple-system,
            sans-serif;
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 1.4;
        color: #1a1d26;
        background: #eef0fc;
        text-decoration: none;
        padding: 0.5rem 1rem;
        border-radius: 10px;
        border: 1px solid transparent;
        cursor: pointer;
        transition:
            background 0.2s ease,
            color 0.2s ease,
            border-color 0.2s ease;
    }

    .personalize-tabs .link a.link-content:hover {
        background: #e0e4fa;
        color: #250891;
    }

    .personalize-tabs .link a.link-content.active {
        color: #fff;
        background: #250891;
        border-color: #250891;
    }

    .personalize-shell {
        padding: 0 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .personalize-shell::-webkit-scrollbar {
        display: none;
    }

    .personalize-form-panel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem 1.5rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
        min-height: 0;
    }

    /* Títulos (TitlePage) — mesmo padrão visual das outras telas admin */
    .personalize-form-panel :deep(.titlelayoutGeneric) {
        margin: 0 0 1.25rem !important;
        padding: 0 0 1rem !important;
        border-bottom: 1px solid #f0f2f5;
        text-align: left;
    }

    .personalize-form-panel :deep(.titlelayoutGeneric.has-margin) {
        margin: 1rem !important;
    }

    .personalize-form-panel :deep(.titlelayoutGeneric h3) {
        font-size: 1.125rem;
        font-weight: 700;
        color: #1a1d26;
        margin: 0 0 0.4rem;
        line-height: 1.3;
    }

    .personalize-form-panel :deep(.titlelayoutGeneric small) {
        display: block;
        font-size: 0.875rem;
        color: #5c6370;
        line-height: 1.5;
    }

    /* Básico + Layout: um único cartão (formulário + ações) */
    .personalize-form-panel :deep(.layoutBasic),
    .personalize-form-panel :deep(.weflix-admin-layoutLayout) {
        background: #fafbfc;
        border: 1px solid #f0f2f5;
        border-radius: 12px;
        overflow: hidden;
    }

    .personalize-form-panel :deep(.layoutBasic > .layout-basic-form-row),
    .personalize-form-panel :deep(.weflix-admin-layoutLayout > .layout-layout-form-row) {
        background: transparent;
        border: none;
        border-radius: 0;
        padding: 1.25rem;
        margin-bottom: 0;
    }

    .personalize-form-panel :deep(.layoutBasic > .actionsSave),
    .personalize-form-panel :deep(.weflix-admin-layoutLayout > .layoutLayoutWeflix.d-flex) {
        margin-top: 0 !important;
        padding: 1rem 1.25rem 1.25rem !important;
        border-top: 1px solid #e8eaf0;
        background: transparent;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: center;
        gap: 0.75rem;
    }

    .personalize-form-panel :deep(.themeSelection),
    .personalize-form-panel :deep(.additionalSettings) {
        background: #fafbfc;
        border: 1px solid #f0f2f5;
        border-radius: 12px;
        padding: 1.25rem;
        margin-bottom: 1.25rem;
    }

    .personalize-form-panel :deep(.additionalSettings) {
        margin-bottom: 0;
    }

    .personalize-form-panel :deep(.titlelayoutThemes) {
        margin: 0 0 1rem;
        padding-bottom: 0.75rem;
        border-bottom: 1px solid #e8eaf0;
        text-align: left;
    }

    .personalize-form-panel :deep(.titlelayoutThemes h3) {
        font-size: 1.05rem;
        font-weight: 700;
        color: #1a1d26;
        margin: 0 0 0.35rem;
    }

    .personalize-form-panel :deep(.titlelayoutThemes small) {
        display: block;
        font-size: 0.875rem;
        color: #5c6370;
        line-height: 1.45;
    }

    .personalize-form-panel :deep(.weflix-admin-socialMediaLayout) {
        background: #fafbfc;
        border: 1px solid #f0f2f5;
        border-radius: 12px;
        overflow: hidden;
    }

    .personalize-form-panel :deep(.weflix-admin-socialMediaLayout .content-form) {
        background: transparent;
        border: none;
        border-radius: 0;
        padding: 1.25rem;
    }

    .personalize-form-panel :deep(.weflix-admin-socialMediaLayout .actionsSave) {
        margin-top: 0 !important;
        padding: 1rem 1.25rem 1.25rem !important;
        border-top: 1px solid #e8eaf0;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 0.75rem;
    }

    .personalize-form-panel :deep(.weflix-admin-advancedLayout) {
        background: #fafbfc;
        border: 1px solid #f0f2f5;
        border-radius: 12px;
        overflow: hidden;
    }

    .personalize-form-panel :deep(.weflix-admin-advancedLayout > .col-form-inner.flex) {
        background: transparent;
        border: none;
        border-radius: 0;
        padding: 1.25rem;
        gap: 1rem;
        margin: 0;
    }

    .personalize-form-panel :deep(.weflix-admin-advancedLayout > .weflix-admin-advancedLayoutBtn) {
        margin-top: 0 !important;
        padding: 1rem 1.25rem 1.25rem !important;
        border-top: 1px solid #e8eaf0;
        display: flex;
        justify-content: flex-end;
        gap: 0.75rem;
    }

    .personalize-form-panel :deep(.weflix-admin-integrationsLayout) {
        background: #fafbfc;
        border: 1px solid #f0f2f5;
        border-radius: 12px;
        overflow: hidden;
    }

    .personalize-form-panel :deep(.weflix-admin-integrationsLayout > .row) {
        background: transparent;
        border: none;
        border-radius: 0;
        padding: 1.25rem;
        margin-left: 0;
        margin-right: 0;
    }

    .personalize-form-panel :deep(.weflix-admin-integrationsLayout > .actionsSave) {
        margin-top: 0 !important;
        padding: 1rem 1.25rem 1.25rem !important;
        border-top: 1px solid #e8eaf0;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        gap: 0.75rem;
    }

    /* Rodapés de ação nas outras abas */
    .personalize-form-panel :deep(.layoutThemesWeflix) {
        margin-top: 1.25rem;
        padding-top: 1.25rem;
        border-top: 1px solid #f0f2f5;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: center;
        gap: 0.75rem;
    }

    .personalize-form-panel :deep(.form-control) {
        border-color: #e0e2e8;
        border-radius: 10px;
    }

    .personalize-form-panel :deep(.form-control:focus) {
        border-color: #250891;
        box-shadow: 0 0 0 3px rgba(37, 8, 145, 0.12);
    }

    .personalize-section.section.config-form.primary {
        display: none;
        background: transparent;
        overflow-x: hidden;
    }

    .personalize-section.section.config-form.primary.active {
        display: block;
        height: auto;
        overflow: visible;
    }

    .container {
        max-width: 100%;
    }

    @media (max-width: 600px) {
        .personalize-tabs {
            flex-wrap: nowrap;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            gap: 0.4rem;
            padding: 0.6rem;
        }

        .personalize-tabs .link a.link-content {
            white-space: nowrap;
        }
    }

    @media (max-width: 500px) {
        .redes-sociais-mobile {
            min-width: fit-content !important;
        }
    }
</style>
